import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import {
  currencyFormatter,
  toAbsoluteUrl,
} from "../../../../../_metronic/_helpers";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../../_metronic/_partials/controls";
import SVG from "react-inlinesvg";
import { BlockOrg } from "../../../../RoleChecker";

export default function ProjectExpense({
  showExpenseModal,
  expenseData,
  removeExpense,
  showConfirmationModal,
  totalProjectExpense
}) {
  const columns = [
    {
      dataField: "date",
      text: "Tgl",
      sort: true,
      footer: "Total Penyaluran",
    },
    {
      dataField: "description",
      text: "Nama Penyaluran",
      sort: true,
      footer: "",
    },
    {
      dataField: "project_category_name",
      text: "Kategori",
      sort: true,
      footer: "",
    },
    {
      dataField: "amount",
      text: "Nominal",
      sort: true,
      formatter: (cell) => {
        return currencyFormatter(cell);
      },
      footer: (cell, row) => {
        // const sum = cell.reduce((prev, curr) => prev + curr, 0);
        return currencyFormatter(totalProjectExpense);
      },
    },
    {
      formatExtraData: {
        blockOrg: BlockOrg(),
      },
      formatter: (cell, row, index, { blockOrg }) => {
        return (
          <>
            <OverlayTrigger
              overlay={
                <Tooltip id="project-edit-tooltip">Edit Expense</Tooltip>
              }
            >
              <a
                className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
                onClick={() => showExpenseModal(row)}
              >
                {row.id}
                <span className="svg-icon svg-icon-md svg-icon-primary">
                  <SVG
                    src={toAbsoluteUrl(
                      "/media/svg/icons/Communication/Write.svg"
                    )}
                  />
                </span>
              </a>
            </OverlayTrigger>
            {blockOrg && (
              <OverlayTrigger
                overlay={
                  <Tooltip id="products-delete-tooltip">Hapus Expense</Tooltip>
                }
              >
                <a
                  className="btn btn-icon btn-light btn-hover-danger btn-sm"
                  onClick={() => showConfirmationModal(row)}
                >
                  <span className="svg-icon svg-icon-md svg-icon-danger">
                    <SVG
                      src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")}
                    />
                  </span>
                </a>
              </OverlayTrigger>
            )}
          </>
        );
      },
      footer: "",
    },
  ];

  return (
    <>
      <Card>
        <CardHeader title="Penyaluran">
          <CardHeaderToolbar>
            {BlockOrg() && (
              <button className="btn btn-primary" onClick={showExpenseModal}>
                Tambah Pengeluaran
              </button>
            )}
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <BootstrapTable
            wrapperClasses="table-responsive"
            classes="table table-head-custom table-vertical-center overflow-hidden"
            bootstrap4
            bordered={false}
            remote
            keyField="uuid"
            data={expenseData}
            columns={columns}
          />
        </CardBody>
      </Card>
    </>
  );
}
